'use client'
import type { ReactNode } from 'react'
import { createContext, useContext, useCallback } from 'react'
import type { IDictionaries } from '@/services/dictionaries'
import type { IServiceError } from '@/types/error'
interface IDictionaryContext {
  dictionaries: IDictionaries
  getDictionary: (key: keyof IDictionaries) => unknown[] | IServiceError
}

const dictionaryContext = createContext<IDictionaryContext | undefined>(undefined)

export function DictionaryProvider({ children, dictionaries }: { children: ReactNode; dictionaries: IDictionaries }) {
  const getDictionary = useCallback(
    (key: keyof IDictionaries) => {
      return dictionaries[key]
    },
    [dictionaries],
  )

  return (
    <dictionaryContext.Provider
      value={{
        dictionaries,
        getDictionary,
      }}
    >
      {children}
    </dictionaryContext.Provider>
  )
}

export function useDictionary() {
  const context = useContext(dictionaryContext)
  if (context === undefined) {
    throw new Error('useDictionary must be used within a DictionaryProvider')
  }
  return context
}
